import React from "react";
import { Button } from 'js/components/atoms';
import { trans } from 'js/utilities';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';

import LogoNio from 'img/logos/logo-nio.svg';
import LogoNioWordmark from 'img/logos/logo-nio-wordmark.svg';
import LogoFirefly from 'img/logos/logo-firefly.svg';
import LogoFireflyWordmark from 'img/logos/logo-firefly-wordmark.svg';

export default function VehicleConfiguratorHeader({ webspaceKey, locale, homeUrl, steps, currentStep, setCurrentStep, inConversionFlow = false, handleClose }) {

    const headerRef = useIntersectionObserver({
        observeSelector: '[data-main-header-intersection-observerable]',
        beforeClass: 'is-top',
        activeClass: 'is-top',
        afterClass: 'is-scroll',
        scrollUpClass: 'is-scroll-up',
        scrollDownClass: 'is-scroll-down'
    });

    const isStepClickable = (stepId, stepIndex) => {
        const currentStepIndex = steps.findIndex((step) => step.id === currentStep);
        if (stepId === currentStep) return true;
        if (stepIndex < currentStepIndex) return true;
        return false;
    };

    const handleStepChange = (newStepId) => {
        const newStepIndex = steps.findIndex((step) => step.id === newStepId);

        if (isStepClickable(newStepId, newStepIndex)) {
            setCurrentStep(newStepId);
        }
    };

    const isConfiguratorStep = currentStep === 'step-3';

    const getPreviousStep = () => {
        if (!steps) return null;
        const currentStepIndex = steps.findIndex(step => step.id === currentStep);
        if (currentStepIndex > 0) {
            return steps[currentStepIndex - 1].id;
        }
        return null;
    };

    return (
        <>
            <div data-main-header-intersection-observerable></div>
            <div
                ref={headerRef}
                className="main-header main-header-configurator"
            >
                <div className={`main-header-bar ${isConfiguratorStep ? 'main-header-bar--configurator' : ''}`}>
                    <div className="container">
                        <div className="main-header-bar-wrapper">
                            <div className={`d-flex align-items-center gap-4 gap-lg-10 h-100${!inConversionFlow ? ' justify-content-between' : ''}`}>
                                <a
                                  className={`header-logo ${inConversionFlow ? 'header-logo-wordmark' : 'header-logo-responsive'}`}
                                  href={homeUrl}
                                >
                                    {inConversionFlow ? (
                                        <img
                                            src={webspaceKey === 'firefly' ? LogoFireflyWordmark : LogoNioWordmark}
                                            alt={`Logo ${webspaceKey}`}
                                        />
                                    ) : (
                                        <>
                                            <img
                                                className="d-lg-none"
                                                src={webspaceKey === 'firefly' ? LogoFirefly : LogoNio}
                                                alt={`Logo ${webspaceKey}`}
                                            />
                                            <img
                                                className="d-none d-lg-block"
                                                src={webspaceKey === 'firefly' ? LogoFireflyWordmark : LogoNioWordmark}
                                                alt={`Logo ${webspaceKey}`}
                                            />
                                        </>
                                    )}
                                </a>
                                {inConversionFlow && (
                                    <Button
                                        text={trans(`webstores_conversion_flow.back`)}
                                        icon="chevron_backward"
                                        onClick={() => handleClose()}
                                    />
                                )}
                                {steps ?
                                    <div className="main-header-steps">
                                        {steps.map((step, index) => {
                                            const isClickable = isStepClickable(step.id, index);
                                            return (
                                                <Button
                                                    key={step.id}
                                                    className={`btn-header-step mb-0 ${step.status}`}
                                                    text={trans(`app.configurator.steps.${step.id}.title`)}
                                                    showIcon={false}
                                                    disabled={!isClickable}
                                                    aria-current={step.id === currentStep ? 'step' : undefined}
                                                    onClick={() => handleStepChange(step.id)}
                                                />
                                            )
                                        })}
                                    </div>
                                : null}
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
                {getPreviousStep() && (
                    <div className="configurator-back-bar">
                        <div className="container">
                            <Button
                                text={trans('app.configurator.previous_step')}
                                icon="chevron_backward"
                                theme="none"
                                onClick={() => setCurrentStep(getPreviousStep())}
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
